import React from 'react';

import { Col, Row } from 'antd';

export const mobileTableRender = (item: any, row: any, extraClasses?: string) => {
	return (
		<Row
			key={item.key}
			align={'middle'}
			style={{
				width: '100%',
				minHeight: 36,
				borderBottom: '1px solid #a9a5a533',
			}}
			className={extraClasses || ''}
			justify={'space-between'}>
			<Col>{item.title}</Col>
			<Col>{item.render ? item.render(row[item.key], row) : row[item.key]}</Col>{' '}
		</Row>
	);
};
